import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import TextField from 'components/forms/textField/TextField';
import Button from 'components/button/Button';
import FormFieldset from 'components/forms/form/FormFieldset';
import LoginFormErrorMessageRenderer from './LoginFormErrorMessageRenderer';

const LoginForm = ({
  errorMessage,
  clearErrors,
  isDesktopServiceProviderUser = false,
  isSubmitting,
  setIsDesktopServiceProviderUser = () => {},
}: {
  errorMessage: string;
  clearErrors: () => void;
  isDesktopServiceProviderUser: boolean;
  isSubmitting: boolean;
  setIsDesktopServiceProviderUser: (value: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { email, password, registrationToken } = useWatch();

  useEffect(() => {
    clearErrors();
    setIsDesktopServiceProviderUser(false);
  }, [email, password]);

  return (
    <FormFieldset disabled={isSubmitting}>
      <TextField
        placeholder={t('pageLogin.emailAddress')}
        colSmInput={12}
        name="email"
        type="email"
        disabled={!!registrationToken}
      />
      <TextField
        placeholder={t('pageLogin.password')}
        colSmInput={12}
        name="password"
        type="password"
      />
      <CheckboxField name="rememberMe">
        {t('pageLogin.rememberMe')}
      </CheckboxField>
      <Button
        data-testid="submit-button"
        disabled={!!errorMessage || isDesktopServiceProviderUser}
        type="submit"
        block
        bsSize="large"
      >
        {t('pageLogin.signIn')}
      </Button>
      <LoginFormErrorMessageRenderer errorMessage={errorMessage} />
    </FormFieldset>
  );
};

export default LoginForm;
